import { Injectable } from "@angular/core";
import { PiramidePoblacionalServiceBackend } from "@serviceBackends";
import { PiramidePoblacionalDTO } from "@DTOS";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class PiramidePoblacionalService {

    constructor(private piramideServiceBackend: PiramidePoblacionalServiceBackend) { }

    public obtenerPiramide(pais: string): Observable<PiramidePoblacionalDTO[]> {
        return this.piramideServiceBackend.getPyramid(pais);
    }

    public obtenerPiramides(): Observable<PiramidePoblacionalDTO[]> {
        return this.piramideServiceBackend.getPyramids();
    }

    public crearPiramide(piramide: Array<PiramidePoblacionalDTO>): Observable<PiramidePoblacionalDTO[]> {
        return this.piramideServiceBackend.postPyramid(piramide);
    }

    public actualizarPiramide(piramide: Array<PiramidePoblacionalDTO>): Observable<PiramidePoblacionalDTO[]> {
        return this.piramideServiceBackend.putPyramid(piramide);
    }

    public eliminarPiramide(pais: string): Observable<boolean> {
        return this.piramideServiceBackend.deletePyramid(pais);
    }
}
